import React from 'react';
import { IToolbar } from './interfaces';
import {
  ColumnsPanelTrigger,
  ToolbarButton,
  Toolbar as ToolbarMui,
} from '@mui/x-data-grid';
import { Tooltip } from '@mui/material';
import ViewColumnIcon from '@mui/icons-material/ViewColumn';
import { SearchInput } from './components/SearchInput';
import { ClearFilterButton } from './components/ClearFilterButton';

export const Toolbar: React.FC<IToolbar> = ({
  searchPlaceholder,
  searchQuery,
  hasActiveFilters = false,
  searchable = true,
  onSearch,
  onClearFilters,
}): JSX.Element => {
  return (
    <ToolbarMui>
      <Tooltip title="Columns">
        <ColumnsPanelTrigger render={<ToolbarButton />}>
          <ViewColumnIcon fontSize="small" />
        </ColumnsPanelTrigger>
      </Tooltip>

      {hasActiveFilters && (
        <ClearFilterButton
          onClick={() => (onClearFilters ? onClearFilters() : null)}
        />
      )}

      {searchable && (
        <SearchInput
          onChange={onSearch}
          placeholder={searchPlaceholder}
          value={searchQuery}
        />
      )}
    </ToolbarMui>
  );
};
